export default __webpack_public_path__ + "static/media/google-play-3x.fe727acc.png";